import { render } from "./BaseOverflowTooltip.vue?vue&type=template&id=97830912&scoped=true"
import script from "./BaseOverflowTooltip.vue?vue&type=script&lang=js"
export * from "./BaseOverflowTooltip.vue?vue&type=script&lang=js"

import "./BaseOverflowTooltip.vue?vue&type=style&index=0&id=97830912&lang=scss&scoped=true"

import exportComponent from "/Users/maksimzugan/code/nacd-3-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97830912"]])

export default __exports__